export const VOTING_STATUS = {
    up: 'UP',
    down: 'DOWN',
    none: 'NONE'
}